<tt-page class="col-xs-12 sp-0">
    <ng-container *ngIf="setting">
        <mgt-login class="col-xs-12 sp-0"></mgt-login>

        <tt-card class="col-xs-12 col-md-4 p-5">
            <tt-select
                class="col-xs-12 sp-0"
                ttRememberId="w_diary.portal_user_keyno"
                ttLabel="portal_user_name"
                [(ttModel)]="setting.portal_user_keyno"
                (ttModelChange)="onPortalUserChanged($event)"
                [ttData]="portalUsers"
                ttDataId="item_id"
                ttDataName="item_name">
            </tt-select>
        </tt-card>

        <div class="col-xs-12 col-md-12 p-5">
            <tt-scheduler
                ttRememberId="diary.scheduler"
                [ttData]="tasks"
                [ttResources]="owners"
                [ttSetup]="setting"
                [ttEditable]="true"
                (ttSelectedDateChange)="onSelectedDateChanged($event)"
                (ttSelectedViewChange)="onSelectedViewChanged($event)"
                (ttEventChange)="onTaskChanged($event)"
                (ttRemove)="onTaskRemoved($event)">
            </tt-scheduler>
        </div>
    </ng-container>
</tt-page>
